<!-- eslint-disable max-len -->
<template>
  <div style="margin-bottom: 10px; margin-top: 10px;">
    <div class="input-group">
      <input style="max-width: 200px" v-model.trim="couponCode" type="text" class="form-control" placeholder="Coupon Code" ref="couponCode">
      <div class="input-group-append">
        <button :disabled="processing || couponCode.length === 0" class="btn" @click="tryApplyCoupon">Apply</button>
      </div>
    </div>
    <div v-if="couponCode && !paymentData.isCouponActive" style="font-style: italic;font-size: 14px;">Note that coupon codes are case-sensitive.</div>
    <p v-if="paymentData.isCouponActive" class="note-text">Using coupon code {{paymentData.couponCode}}</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  components: {},
  props: {
    course: Object,
    paymentData: Object
  },
  data() {
    return {
      couponCode: '',
      processing: false
    };
  },
  methods: {
    ...mapActions([
      'getClassPurchaseData'
    ]),

    async tryApplyCoupon() {
      this.processing = true;
      try {
        const coupon = await this.getClassPurchaseData({
          classId: this.course._id,
          couponCode: this.couponCode
        });

        if (coupon) {
          this.$emit('coupon-applied', coupon);
        }
      } catch (ex) {
        if (ex.response) {
          // TODO: update alert to use better UX?
          // eslint-disable-next-line no-alert
          alert(ex.response.data);
        }
        console.error(ex);
      }
      this.processing = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/braintree/CouponEntry.vue